var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button text gray",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"icon arrow-left"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.back')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }